exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/app/components/bookmark-templates/bookmarks-dialog/bookmarks-dialog.component.css
// module id = 763
// module chunks = 0